<script lang="ts" setup>
import type { UsefulLink } from './UsefulLink.types'

defineProps<UsefulLink>()
</script>

<template>
  <article class="useful-link">
    <h3 class="useful-link__title">
      {{ title }}
    </h3>

    <a
      :href="url"
      class="useful-link__link"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ $t('common.visitWebsite') }}

      <img
        class="useful-link__svg"
        src="/icons/icn_arrow_right.svg"
        aria-hidden="true"
      >
    </a>
  </article>
</template>

<style lang="scss" scoped>
.useful-link {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  height: 100%;
  padding: 3.2rem;
  background-color: $gray-100;
  border: 1px solid $base-50;
  border-radius: 1.2rem;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: $white;
  }

  &__title {
    @include h10;
    flex: 1 0 auto;
    color: $text-400;
  }

  &__link {
    display: flex;
    align-items: center;
    gap: 0.8rem;
    margin-top: auto;
    color: $text-400;
    cursor: pointer;
    @include body-3-medium;
    transition: color 0.2s ease;

    &:hover {
      color: $text-300;
    }
  }
}
</style>
